<template>
<div class="contact__wrapper schadensmeldung">
  <v-app class="ast-container">
  <div class="row">
  <div class="col-24 col-xl-12 offset-xl-6">
    <contact-form :name="name" buttonText="Schaden melden" :requiredFields="requiredFields">
      <schadensmeldung-form></schadensmeldung-form>
    </contact-form>
  </div>
  </div>
  </v-app>
</div>
</template>

<script>
import ContactForm from "./ContactForm.vue";
import SchadensmeldungForm from "./SchadensmeldungForm";

export default {
  name: "SchadensmeldungApp",

  components: {
    ContactForm,
    SchadensmeldungForm
  },

  data() {
    return {
      name: "schadensmeldung"
    }
  },

  computed: {
    requiredFields() {
      return this.$yeti.formRequiredFields(this.name);
    }
  }
};
</script>
